import { useState, useEffect } from "react";

function StairEditor({ stair, onUpdate, onDelete, onDeselect }) {
  const [width, setWidth] = useState(String(stair.width));
  const [length, setLength] = useState(String(stair.length));
  const [angle, setAngle] = useState(String(stair.angle || 0));

  useEffect(() => {
    setWidth(String(stair.width));
    setLength(String(stair.length));
    setAngle(String(stair.angle || 0));
  }, [stair.id, stair.width, stair.length, stair.angle]);

  const commitNumber = (val, fallback, field, min = 0.3) => {
    const v = parseFloat(val);
    if (!isNaN(v) && v >= min) onUpdate({ [field]: Math.round(v * 10) / 10 });
    else fallback();
  };

  const handleAngleBlur = () => {
    let v = parseFloat(angle);
    if (isNaN(v)) {
      setAngle(String(stair.angle || 0));
      return;
    }
    v = ((v % 360) + 360) % 360;
    onUpdate({ angle: v });
    setAngle(String(v));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") e.target.blur();
  };

  const rotate = (delta) => {
    const v = ((((stair.angle || 0) + delta) % 360) + 360) % 360;
    onUpdate({ angle: v });
  };

  return (
    <div className="room-editor">
      <div className="room-editor-header">
        <h3>Stairs Editor</h3>
        <button className="btn-icon" onClick={onDeselect} title="Deselect">
          ✕
        </button>
      </div>

      <div className="room-editor-field">
        <label>Direction</label>
        <div className="door-type-group">
          <button
            className={`door-type-btn ${stair.direction !== "down" ? "active" : ""}`}
            onClick={() => onUpdate({ direction: "up" })}
          >
            ↑ Up
          </button>
          <button
            className={`door-type-btn ${stair.direction === "down" ? "active" : ""}`}
            onClick={() => onUpdate({ direction: "down" })}
          >
            ↓ Down
          </button>
        </div>
      </div>

      <div className="room-editor-dimensions">
        <div className="dim-field">
          <label>Width (m)</label>
          <input
            type="number"
            step="0.1"
            min="0.5"
            value={width}
            onChange={(e) => setWidth(e.target.value)}
            onBlur={() => commitNumber(width, () => setWidth(String(stair.width)), "width", 0.5)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="dim-field">
          <label>Run (m)</label>
          <input
            type="number"
            step="0.1"
            min="0.5"
            value={length}
            onChange={(e) => setLength(e.target.value)}
            onBlur={() => commitNumber(length, () => setLength(String(stair.length)), "length", 0.5)}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="dim-field">
          <label>Angle (°)</label>
          <input
            type="number"
            step="15"
            value={angle}
            onChange={(e) => setAngle(e.target.value)}
            onBlur={handleAngleBlur}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>

      <div className="door-rotate-row">
        <button className="btn-secondary" onClick={() => rotate(-90)} title="Rotate 90° left">
          ↺ 90°
        </button>
        <button className="btn-secondary" onClick={() => rotate(90)} title="Rotate 90° right">
          ↻ 90°
        </button>
      </div>

      <p className="editor-hint">Drag the staircase on the map to position it. The arrow points in the &ldquo;up&rdquo; direction.</p>

      <div className="room-editor-actions">
        <button className="btn-secondary btn-danger" onClick={onDelete}>
          Delete Stairs
        </button>
      </div>
    </div>
  );
}

export default StairEditor;
